// extracted by mini-css-extract-plugin
export default {"overlay":"jC-z","bodyOpen":"kC-z","content":"lC-z","header":"mC-z","close":"nC-z","closeNoHeading":"oC-z"};